import { MessageInstance } from 'antd/es/message/interface';
import auth from 'api/auth';
import { TFunction } from 'i18next';
import { NavigateFunction } from 'react-router';

export const validateActivateLink = async (
  link_id: string,
  t: TFunction,
  navigate: NavigateFunction,
  isPasswordChange?: boolean,
  modalCloseFunc?: () => void,
  messageApi?: MessageInstance | null,
) => {
  const response = await auth.validateLink(link_id);  
  if (!response.data.is_valid) {
    if (modalCloseFunc) modalCloseFunc()
    else navigate('/');

    isPasswordChange
      ? messageApi?.warning(t('Confirm.linkExpiredPass'))
      : messageApi?.warning(t('Confirm.linkExpired'));
  }
  return response;
};
